import React from 'react'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { Skeleton } from '@material-ui/lab'
import { isFunction } from 'libraries/lodash'
import Icon from 'components/shared/Icon'

const KeyPicks = ({
  keyPicks,
  getUrl,
  iconName,
  pending,
  className = '',
  cxNames = '',
  getItemDataAttributes = null,
  newTab = true
}) => {
  return (
    <section className={className}>
      <Grid container spacing={0}>
        {(pending ? [...Array(3)] : keyPicks).map((item, index) => {
          const props = pending
            ? {}
            : {
                href: getUrl(item),
                ...(isFunction(getItemDataAttributes) ? getItemDataAttributes(item) : {})
              }

          return (
            <Grid key={index} item xs={12} sm={4}>
              <a
                {...props}
                target={newTab ? '_blank' : undefined}
                rel={newTab ? 'noopener noreferrer' : undefined}
                className={cx(
                  cxNames.tile.borderColor,
                  'relative h6 h4-m bg-white bb-thick db flex items-center justify-between',
                  'black f5 no-underline hover-cadet-blue hover-underline ph6 ph7-m'
                )}
              >
                <Grid container justify='space-between' alignItems='center'>
                  <Grid item xs={11}>
                    {
                      pending
                        ? <Skeleton width='65%' />
                        : (
                          <h3 className='lh-solid f5 fw6'>
                            {item.title}
                          </h3>
                          )
                    }
                  </Grid>
                  {!!iconName && (
                    <Hidden only='sm'>
                      <Grid item xs={1}>
                        <Icon name={iconName} className='w7 vm black' />
                      </Grid>
                    </Hidden>
                  )}
                </Grid>
                {index !== 0 && (
                  <Hidden xsDown>
                    <div className={cx('absolute left0 top-50 y--50 h-50 bl b--black', cxNames.tile.borderColor)} />
                  </Hidden>
                )}
              </a>
            </Grid>
          )
        })}
      </Grid>
    </section>
  )
}

export default KeyPicks
